/**
 * Schakelaar tussen de weergaven van de projectpagina (gebruikersvoorkeur, onthouden per browser):
 *   'rustig' — de nieuwe rustige projectpagina (standaard op test en lokaal)
 *   'flow'   — de vorige flow-weergave met fasenbalk en werkvlak (standaard op productie)
 *   'tabs'   — de oude tabbladen
 *
 * URL wint van de voorkeur: ?weergave=tabs | rustig | klassiek. ?weergave=flow is een bestaande
 * deeplink ("toon de fase", vanaf het PL-dashboard en Inplannen) en betekent: een fase-weergave,
 * welke de gebruiker ook prefereert — nooit de tabbladen.
 */

export const WEERGAVE_SLEUTEL = 'projectPaginaWeergave';
const OUDE_SLEUTEL = 'projectWeergave';
export const WEERGAVEN = ['rustig', 'flow', 'tabs'];

const TEST_HOSTS = new Set(['test.fullframe.nl', 'localhost', '127.0.0.1']);

export function standaardWeergave(host) {
  return TEST_HOSTS.has(String(host || '')) ? 'rustig' : 'flow';
}

/** Voorkeur uit de opslag; wie eerder bewust de tabbladen koos, houdt die. */
export function leesVoorkeur(opslag, host) {
  try {
    const v = opslag?.getItem(WEERGAVE_SLEUTEL);
    if (WEERGAVEN.includes(v)) return v;
    if (opslag?.getItem(OUDE_SLEUTEL) === 'tabs') return 'tabs';
  } catch { /* privémodus: standaard */ }
  return standaardWeergave(host);
}

export function bewaarVoorkeur(opslag, weergave) {
  if (!WEERGAVEN.includes(weergave)) return;
  try {
    opslag?.setItem(WEERGAVE_SLEUTEL, weergave);
    // De vorige flow-code leest de oude sleutel nog (bv. opstarten vanuit de tabbladen).
    opslag?.setItem(OUDE_SLEUTEL, weergave === 'tabs' ? 'tabs' : 'flow');
  } catch { /* privémodus: alleen voor deze sessie */ }
}

export function kiesWeergave({ url, voorkeur, host }) {
  if (url === 'tabs') return 'tabs';
  if (url === 'rustig') return 'rustig';
  if (url === 'klassiek') return 'flow';
  if (url === 'flow') return voorkeur === 'tabs' ? standaardWeergave(host) : voorkeur;
  return WEERGAVEN.includes(voorkeur) ? voorkeur : standaardWeergave(host);
}
